import { useTranslation } from 'react-i18next';
import { useCustomerTrends } from '../hooks/useDataQuality';
import { TrendBadge } from './TrendBadge';

/** FR23: completeness-trend for this client (improving/stable/declining, monthly). */
export function TrendPanel({ gln }: { gln: string }) {
  const { t } = useTranslation();
  const { data, isLoading } = useCustomerTrends(gln);
  const trend = data?.data.trend;

  if (isLoading) {
    return <div data-testid="trend-panel-skeleton" className="skeleton h-9 w-32 rounded-lg" />;
  }

  if (!trend) {
    return null;
  }

  return (
    <div data-testid="trend-panel" className="flex items-center gap-2">
      <span className="text-xs" style={{ color: 'var(--foreground-muted)' }}>
        {t('dataQuality.trend.label')}
      </span>
      <TrendBadge trend={trend} />
    </div>
  );
}
